<template>
  <div class="main">
    <div class="goods-detail">
      <div class="gd-title">
        <van-tag plain type="success" class="tag" v-if="dataInfo.EvaluateType === 0">评价</van-tag>
        <van-tag plain type="danger" class="tag" v-else>追评</van-tag>
        订单编号：{{ dataInfo.PlatformOrderID || '----' }}
      </div>
      <div class="gd-detail">
        <div class="gd-img"><img :src="dataInfo.PicUrl" alt="" /></div>
        <div class="gd-content">
          <div class="gd-content-title">
            <!-- <span class="platform-tag pdd" v-if="ShopType === 2"
              >拼多多</span
            >
            <span class="platform-tag tm" v-if="ShopType === 1">天猫</span> -->
            <plat-formLogo :shopType="$utils.shopTypeNumChangeToText(dataInfo.ShopType)"></plat-formLogo>
            <template>{{ dataInfo.Title || '----' }}</template>
          </div>
          <div class="gd-price">
            <span class="price-btn">评价奖励</span>
            <span>免单卡 x {{ dataInfo.RewardFreeCard }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-cell">
      <!-- 文字 -->
      <div class="cell-item">
        <div class="cell-left">评价字数</div>
        <div class="cell-right">
          <div>
            <template v-if="dataInfo.WordNumType === 0">
              <span class="cell-right-tip">20字</span>
              <span>20个字以上</span>
            </template>
            <template v-else>
              <span class="cell-right-tip">不限</span>
              <span>无字数限制</span>
            </template>
          </div>
          <p class="sug" v-if="dataInfo.TextSuggest">建议：{{ dataInfo.TextSuggest }}</p>
        </div>
      </div>
      <!-- 图片 -->
      <div class="cell-item">
        <div class="cell-left">晒图要求</div>
        <div class="cell-right">
          <div>
            <!--
              PicType = 0：图片5张
              PicType = 1：图片1到4张
              PicType = 2：不要晒图
              PicType = 3：晒图
            -->
            <template v-if="dataInfo.PicType === 0">
              <span class="cell-right-tip">5张</span>
              <span>晒5张商品图</span>
            </template>
            <template v-else-if="dataInfo.PicType === 1">
              <span class="cell-right-tip">1~4张</span>
              <span>晒1~4张商品图</span>
            </template>
            <template v-else-if="dataInfo.PicType === 3">
              <span class="cell-right-tip">{{ dataInfo.CustomizePicCount }}张</span>
              <span>晒{{ dataInfo.CustomizePicCount }}张商品图</span>
            </template>
            <template v-else>
              <span class="cell-right-tip">不晒</span>
              <span>不要晒图</span>
            </template>
          </div>
          <p class="sug" v-if="dataInfo.PicType !== 2 && dataInfo.PicSuggest">建议：{{ dataInfo.PicSuggest }}</p>
        </div>
      </div>
      <!-- 视频 -->
      <div class="cell-item" v-if="dataInfo.ShowVedio">
        <div class="cell-left">视频要求</div>
        <div class="cell-right">
          <div>
            <span class="cell-right-tip">5秒</span>
            <span>晒5秒以上视频</span>
          </div>
          <p class="sug" v-if="dataInfo.VideoSuggest">建议：{{ dataInfo.VideoSuggest }}</p>
        </div>
      </div>
    </div>
    <div class="upload-mian">
      <template v-if="dataInfo.PicType === 0">
        <div v-if="dataInfo.ShowVedio" class="up-explain">
          请按要求评价并上传截图。文字、晒图及视频均要与商品相关，并且不能堆砌文字，否则无法获得评价奖励。
        </div>
        <div v-else class="up-explain">
          请按要求评价并上传截图。文字和晒图要与商品相关，并且不能堆砌文字，否则无法获得评价奖励。
        </div>
      </template>
      <template v-else>
        <div v-if="dataInfo.ShowVedio" class="up-explain">
          请按要求评价并上传截图。文字、晒图要与商品相关，并且不能堆砌文字、不能上传重复图片，否则无法获得评价奖励。
        </div>
        <div v-else class="up-explain">
          请按要求评价并上传截图。文字要与商品相关，并且不能堆砌文字，否则无法获得评价奖励。
        </div>
      </template>
      <div class="up-step">
        <div class="up-step-title"><span class="iconfont icon-dingwei"></span><span>截图位置</span></div>
        <div class="up-step-steps" v-if="ShopType === 4">
          抖音APP - 我 - 抖音商城 - 评价 - 评价详情
        </div>
        <div class="up-step-steps" v-else-if="ShopType === 3">
          京东APP - 我的 - 待评价 - 已评价/追评 - 评价详情
        </div>
        <div class="up-step-steps" v-else-if="ShopType === 2">
          拼多多App - 个人中心 - 查看全部订单 - 点击已评价的订单 - 我的评价 - 评价详情
        </div>
        <div class="up-step-steps" v-else>
          淘宝App - 我的淘宝 - 订单栏的待评价 - 已评价
        </div>
      </div>
      <!-- upload-->
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-uploader">
            <div class="weui-uploader__bd">
              <div class="weui-uploader__files">
                <div class="weui-uploader__input-box">
                  <div class="weui-uploader__input">
                    <input type="file" class="upload-input" accept="image/*" @change="selectImgChange($event)" />
                  </div>
                </div>
                <div
                  v-if="isUploading || isUploadFail || uploadImgSrc"
                  class="weui-uploader__file"
                  :class="[isUploading || isUploadFail ? 'weui-uploader__file_status' : '']"
                  @click="previewImage('upload')"
                >
                  <img class="weui-uploader__img" v-if="uploadImgSrc" :src="uploadImgSrc" />
                  <div class="weui-uploader__file-content" v-if="isUploading">{{ uploadingProgress }}%</div>
                  <div class="weui-uploader__file-content" v-if="isUploadFail">
                    <i>图片上传失败</i>
                  </div>
                </div>
                <div class="weui-uploader__file weui-uploader__file_status" @click="previewImage('exam')">
                  <img class="weui-uploader__img" :src="sampleImg" />
                  <div class="weui-uploader__file-content">示例</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-btn b_fff flex">
        <!-- <mt-button type="default" @click="cancelHandel">取消评价</mt-button> -->
        <div class="leftPart tapActive" @click="cancelHandel">取消评价</div>
        <div class="rightPart">
          <div>
            <mt-button type="default" @click="goBack">返回</mt-button>
          </div>
          <div class="btn-margin">
            <mt-button type="danger" @click="invitationSubmit">立即提交</mt-button>
          </div>
        </div>
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :class="[ShopType === 2 ? 'fill-w' : '']" :img-src="previewImgSrc"> </preview-dialog>
  </div>
</template>

<script>
import { Tag } from 'vant'
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { UpaiyunUploadInfoGet } from '@/api/order'
import { SAppEvaluateInfoGet, SAppEvaluateSubmit, CancelEvaluate } from '@/api/invitation'

export default {
  components: {
    PreviewDialog,
    'van-tag': Tag
  },
  data() {
    return {
      id: '',
      taskId: '',
      isUploading: false,
      isUploadFail: false,
      uploadingProgress: 0,
      uploadImgSrc: '',
      uploadUserInfo: {},
      ShopType: 0, // 0、1：淘宝 2：拼多多 3：京东
      showRootPath: IMG_BASE_URL,
      sampleHavePic: IMG_BASE_URL + '/upaiyun/Sys/20180907/5656533790374505730.jpg',
      sampleNoPic: IMG_BASE_URL + '/upaiyun/Sys/20180907/5449797718861806357.jpg',
      sampleVideoPic: IMG_BASE_URL + '/upaiyun/Sys/20190318/5424139121060976217.jpg',
      // 拼多多
      pddSampleHavePic: IMG_BASE_URL + '/upaiyun/Sys/20200407/5510638623490910388.jpg',
      pddSampleNoPic: IMG_BASE_URL + '/upaiyun/Sys/20200407/4691567324773398791.jpg',
      pddSampleVideoPic: IMG_BASE_URL + '/upaiyun/Sys/20200407/5083654060424119724.jpg',
      // 京东
      jdSampleHavePic: IMG_BASE_URL + '/upaiyun/Sys/20211215/5224710254971870634.jpeg',
      jdSampleNoPic: IMG_BASE_URL + '/upaiyun/Sys/20211215/5250479793910563633.jpeg',
      jdSampleVideoPic: IMG_BASE_URL + '/upaiyun/Sys/20211215/5045586340766350981.jpeg',
      // 抖音
      dySampleHavePic: IMG_BASE_URL + '/upaiyun/Sys/20220125/5752527107263222571.jpg',
      dySampleNoPic: IMG_BASE_URL + '/upaiyun/Sys/20220125/5298875824906788650.jpg',
      dySampleVideoPic: IMG_BASE_URL + '/upaiyun/Sys/20220218/4981844741642736033.jpg',
      sampleImg: '',
      dataInfo: {},
      previewImgSrc: '',
      previewDialogShow: false,
      timeOut: null
    }
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : null
    this.taskId = this.$route.query.taskId ? this.$route.query.taskId : null
    console.log(this.id, this.taskId)
    this.sampleImg = this.sampleHavePic
  },
  beforeDestroy() {
    if (this.timeOut) {
      clearTimeout(this.timeOut)
    }
  },
  mounted() {
    if (this.id) {
      this.fetchData()
      this.fetchUploadInfo()
    } else {
      Toast('信息出错，请重新进入')
      this.$router.go(-1)
    }
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      SAppEvaluateInfoGet({ id: this.id, taskId: this.taskId })
        .then((res) => {
          Indicator.close()
          this.ShopType = res.Data.ShopType
          this.setSampleImg(res.Data.ShowVedio, res.Data.PicType)
          this.dataInfo = res.Data
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
            this.$router.go(-1)
          }
        })
    },
    // 获取上传图片信息
    fetchUploadInfo() {
      UpaiyunUploadInfoGet()
        .then((res) => {
          this.uploadUserInfo.uploadUrl = res.UploadUrl
          this.uploadUserInfo.loginName = res.LoginName
          this.uploadUserInfo.password = res.Screct
        })
        .catch((res) => {
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    // 设置评价说明示例图
    setSampleImg(showVedio, picType) {
      if (showVedio) {
        switch (this.ShopType) {
          case 2:
            // 拼多多
            this.sampleImg = this.pddSampleVideoPic
            break
          case 3:
            // 京东
            this.sampleImg = this.jdSampleVideoPic
            break
          case 4:
            // 抖音
            this.sampleImg = this.dySampleVideoPic
            break
          default:
            // 0、1淘宝、天猫
            this.sampleImg = this.sampleVideoPic
            break
        }
      } else {
        if (picType === 2) {
          switch (this.ShopType) {
            case 2:
              // 拼多多
              this.sampleImg = this.pddSampleNoPic
              break
            case 3:
              // 京东
              this.sampleImg = this.jdSampleNoPic
              break
            case 4:
              // 抖音
              this.sampleImg = this.dySampleNoPic
              break
            default:
              // 0、1淘宝、天猫
              this.sampleImg = this.sampleNoPic
              break
          }
        } else {
          switch (this.ShopType) {
            case 2:
              // 拼多多
              this.sampleImg = this.pddSampleHavePic
              break
            case 3:
              // 京东
              this.sampleImg = this.jdSampleHavePic
              break
            case 4:
              // 抖音
              this.sampleImg = this.dySampleHavePic
              break
            default:
              // 0、1淘宝、天猫
              this.sampleImg = this.sampleHavePic
              break
          }
        }
      }
    },
    // 图片上传
    selectImgChange(event) {
      let _this = this
      let rootPath = this.showRootPath
      let file = event.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('souhuoInvitatinUpload', file)
        document.querySelector('.upload-input').value = ''
        axios({
          method: 'post',
          url: this.uploadUserInfo.uploadUrl,
          params: {
            loginName: this.uploadUserInfo.loginName,
            secret: this.uploadUserInfo.password
          },
          data: data,
          timeout: 60000,
          onUploadProgress: function(progressEvent) {
            // 显示相应的上传进度
            let percent = (progressEvent.loaded / progressEvent.total) * 100
            _this.uploadingProgress = parseInt(percent)
            _this.isUploading = true
            _this.isUploadFail = false
          }
        })
          .then((res) => {
            if (res.status === 200 && res.data.StatusCode === 200) {
              // 上传成功，展示图片，隐藏进度条
              this.uploadImgSrc = rootPath + res.data.Message
              this.isUploading = false
              this.isUploadFail = false
            } else {
              Toast(res.Message)
              this.uploadingProgress = 0
              this.uploadImgSrc = ''
              this.isUploading = false
              this.isUploadFail = true
            }
          })
          .catch(() => {
            Toast('上传图片失败！请重新上传')
            this.uploadingProgress = 0
            this.uploadImgSrc = ''
            this.isUploading = false
            this.isUploadFail = true
          })
      }
    },
    previewImage(type) {
      if (type === 'upload') {
        this.previewImgSrc = this.uploadImgSrc
      } else if (type === 'exam') {
        this.previewImgSrc = this.sampleImg
      }
      this.previewDialogShow = true
    },
    goBack() {
      this.$router.go(-1)
    },
    // 提交
    invitationSubmit() {
      if (this.isUploadFail) {
        Toast('上传图片失败，请重新上传后再提交')
        return
      }
      if (this.isUploading) {
        Toast('正在上传图片，请稍后再提交')
        return
      }
      if (!this.uploadImgSrc) {
        Toast('请先上传评价截图')
        return
      }
      let postData = {
        id: this.dataInfo.ID ? this.dataInfo.ID : this.id,
        pic: this.uploadImgSrc
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      SAppEvaluateSubmit(postData)
        .then((res) => {
          Indicator.close()
          if (res.Msg) {
            Toast('提交成功')
            this.timeOut = setTimeout(() => {
              this.$router.push({
                name: 'orderSuccess',
                query: {
                  ismanual: false,
                  isInvitation: true,
                  time: decodeURIComponent(res.Msg),
                  productID: this.dataInfo.ProductID,
                  titleShort: this.dataInfo.TitleShort
                }
              })
            }, 300)
          }
        })
        .catch((err) => {
          Toast(err.ErrMsg)
          Indicator.close()
        })
    },
    // 取消评价
    cancelHandel() {
      MessageBox({
        title: '提示',
        message: `取消后将失去获得${this.dataInfo.RewardFreeCard}张免单卡的评价机会，确认取消该笔评价吗？`,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 't_f23030'
      })
        .then((action) => {
          if (action === 'confirm') {
            Indicator.open({
              text: '加载中',
              spinnerType: 'triple-bounce'
            })
            CancelEvaluate({ id: this.id }).then((res) => {
              Indicator.close()
              this.$toast(res.Msg)
              this.goBack()
            })
          }
        })
        .catch((err) => {
          Indicator.close()
          this.$toast(err.ErrMsg)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'orderSuccess') {
      next({ name: 'souhuo' })
    } else {
      next()
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  font-size: 12px;
}
.goods-detail {
  background: #fff;
  font-size: 14px;
}
.gd-title {
  display: flex;
  align-items: center;
  height: 3em;
  line-height: 3em;
  color: #999;
  border-bottom: 1px solid #eee;
  padding: 0 3%;
  .tag {
    margin-right: 4px;
  }
}
.gd-detail {
  padding: 3% 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  font-size: 14px;
}
.gd-img {
  width: 7em;
  height: 7em;
  margin-right: 0.7em;
  flex-shrink: 0;
}
.gd-img img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
  background: #f5f5f5;
}
.gd-content {
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-between;
}
.gd-content-title {
  max-height: 2.8em;
  line-height: 1.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.gd-price {
  height: 30px;
  line-height: 30px;
}
.price-btn {
  font-size: 12px;
  color: #fff;
  background: #f05c61;
  border-radius: 8px;
  padding: 3px 6px;
  margin-right: 10px;
}
.submit-cell {
  overflow: hidden;
}
.cell-item {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  min-height: 30px;
  padding: 10px 2%;
  margin-top: 3%;
  background: #fff;
  font-size: 14px;
}
.cell-item .cell-left {
  flex-shrink: 0;
  margin-right: 10px;
}
.cell-item .cell-right {
  position: relative;
  margin-left: 10px;
}
.cell-item .cell-right::before {
  content: '';
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: -11px;
  width: 1px;
  background: #eee;
}
.cell-item .cell-right .sug {
  color: #999;
  margin-top: 5px;
}
.cell-right-tip {
  color: #f23030;
  font-size: 12px;
  border: 1px solid #f23030;
  border-radius: 6px;
  background: #fff;
  padding: 1px 6px;
  margin-right: 10px;
}

/* upload */
.upload-mian {
  background: #fff;
  margin-top: 3%;
  padding-bottom: 4em;
}
.up-explain {
  position: relative;
  height: 4em;
  line-height: 1.5em;
  color: #fff;
  font-size: 13px;
  padding: 5px 5px 5px 3%;
  box-sizing: border-box;
  background: #2c2c2c;
}
.up-explain::before {
  content: '';
  position: absolute;
  top: 50px;
  left: 35px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top-color: #2c2c2c;
}
.up-step {
  margin: 20px 10px 10px 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}
.up-step-title {
  position: relative;
  padding-left: 20px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
}
.up-step-title .iconfont {
  position: absolute;
  left: 0;
  top: 0;
  color: #f05c61;
  font-size: 20px;
}
.up-step-steps {
  color: #999;
  font-size: 14px;
  padding-left: 20px;
}
.weui-cells {
  margin-top: 0;
  border-top: none;
}
.weui-cells::before {
  content: '';
  border: none;
}
.weui-cells::after {
  content: '';
  border: none;
}
.order-btn {
  justify-content: space-between;
  position: fixed;
  align-items: center;
  bottom: 0;
  height: 65px;
  line-height: 65px;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  overflow: hidden;
  padding-left: 15px;
}
.leftPart {
  font-size: 14px;
  color: #656b79;
}
.rightPart {
  display: flex;
  align-items: center;
}
.order-btn button {
  font-size: 14px;
  padding: 0px 15px;
  height: 2.5em;
  line-height: 2.5em;
  margin: 0;
}
.order-btn .btn-margin {
  margin: 0 15px;
}
.fill-w >>> .img-main img {
  width: 86%;
}
@media screen and (max-height: 568px) {
  .up-explain {
    height: 5em;
  }
}
/**
    upload
   */
.upload-input {
  height: 100%;
  width: 100%;
  display: block;
}
.weui-cell {
  padding: 10px 15px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 3 4%;
  min-height: 2.5em;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: hidden;
}
.weui-uploader__input-box {
  float: left;
  position: relative;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 77px;
  height: 77px;
  border: 1px solid #d9d9d9;
}
.weui-uploader__input-box:before {
  width: 2px;
  height: 39.5px;
}
.weui-uploader__input-box:before,
.weui-uploader__input-box:after {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input-box:after {
  width: 39.5px;
  height: 2px;
}
.weui-uploader__input-box:before,
.weui-uploader__input-box:after {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.weui-uploader__img {
  display: block;
  width: 79px;
  height: 79px;
  overflow: hidden;
}
.weui-uploader__file {
  float: left;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 79px;
  height: 79px;
  background: no-repeat center center;
  background-size: cover;
}
.weui-uploader__file_status {
  position: relative;
  display: block;
}
.weui-uploader__file_status:before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.weui-uploader__file-content {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
}
</style>
